import {
  convertDateByTimezone,
  formatToDate,
  formatWithGmtOffset,
} from 'helpers';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';
import {
  useField,
  useFormContext,
} from 'modules/operation/common/forms/operationForm';
import { OperationMode } from 'modules/operation/common/types';

interface OrderFieldsProps {
  brokerTimezoneOffset: number;
  mode: OperationMode;
}

export const OrderFields = ({
  brokerTimezoneOffset,
  mode,
}: OrderFieldsProps) => {
  const { t } = useTranslation();

  const { readOnly } = useFormContext();

  const { field } = useField('order');

  const startDate = field.value?.record?.startDate
    ? formatWithGmtOffset(
        convertDateByTimezone(
          field.value?.record?.startDate,
          brokerTimezoneOffset
        ),
        brokerTimezoneOffset,
        formatToDate
      )
    : '';

  const endDate = field.value?.record?.endDate
    ? formatWithGmtOffset(
        convertDateByTimezone(
          field.value?.record?.endDate,
          brokerTimezoneOffset
        ),
        brokerTimezoneOffset,
        formatToDate
      )
    : '';

  return (
    <>
      <Input
        readOnly
        showCopyButton
        disabled={!readOnly}
        label={t(
          'operation.sections.clientsOrderSection.fields.orderOperationType.label'
        )}
        value={
          field.value?.record?.operationType
            ? t(`order.operationTypes.${field.value?.record?.operationType}`)
            : ''
        }
      />
      {mode === 'view' && (
        <Input
          readOnly
          showCopyButton
          disabled={!readOnly}
          label={t(
            'operation.sections.clientsOrderSection.fields.orderStatus.label'
          )}
          value={
            field.value?.record?.status
              ? t(`order.status.${field.value?.record?.status}`)
              : ''
          }
        />
      )}
      <Input
        readOnly
        showCopyButton
        disabled={!readOnly}
        label={t(
          'operation.sections.clientsOrderSection.fields.orderStartDate.label'
        )}
        value={startDate}
      />
      <Input
        readOnly
        showCopyButton
        disabled={!readOnly}
        label={t(
          'operation.sections.clientsOrderSection.fields.orderEndDate.label'
        )}
        value={endDate}
      />
      <Input
        readOnly
        showCopyButton
        disabled={!readOnly}
        label={t(
          'operation.sections.clientsOrderSection.fields.orderType.label'
        )}
        value={
          field.value?.record?.orderType
            ? t(
                `order.executionTermsOrderType.${field.value?.record?.orderType}`
              )
            : ''
        }
      />

      <Input
        readOnly
        showCopyButton
        disabled={!readOnly}
        label={t(
          'operation.sections.clientsOrderSection.fields.orderMarketType.label'
        )}
        value={
          field.value?.record?.marketType
            ? t(`order.marketType.${field.value?.record?.marketType}`)
            : ''
        }
      />
    </>
  );
};
